import { Select, Tag } from '@bancobarigui/barihaus';
import { useChecklistContext } from '@/pages/ChecklistNew/contexts/ChecklistContext';

interface TagsFieldProps {
  value: string[];
  onChange: (tags: string[]) => void;
  label?: string;
}

export function TagsField({ value, onChange, label = 'Tags' }: TagsFieldProps) {
  const { availableTags, loadingTags: loading } = useChecklistContext();

  const normalizedValue = (value || []).map((tag: any) => {
    if (typeof tag === 'string') return tag;
    if (tag && typeof tag === 'object' && tag.name) return tag.name;
    return String(tag);
  });

  const options = availableTags.map(tag => ({
    value: tag.name,
    label: tag.name,
  }));

  const handleSelect = (selectedValue: string) => {
    const newTags = [...normalizedValue, selectedValue];
    onChange(newTags);
  };

  const handleDeselect = (deselectedValue: string) => {
    const newTags = normalizedValue.filter(tag => tag !== deselectedValue);
    onChange(newTags);
  };

  return (
    <div>
      <style>{`
        .ant-tag-close-icon {
          color: #000 !important;
        }
        .ant-tag-close-icon:hover {
          color: #ff4d4f !important;
        }
      `}</style>
      <label className="block text-sm font-medium text-gray-600 mb-2">
        {label}
      </label>
      <Select
        mode="multiple"
        size="middle"
        className="w-full"
        value={normalizedValue as any}
        onSelect={handleSelect}
        onDeselect={handleDeselect}
        onClear={() => onChange([])}
        placeholder="Selecione as tags"
        loading={loading}
        options={options as any}
        showSearch
        allowClear
        maxTagCount="responsive"
        filterOption={(input: string, option: any) => {
          const label = option?.label || option?.children || '';
          const search = input.toLowerCase();
          return label.toLowerCase().includes(search);
        }}
        tagRender={(props) => {
          const { label: tagLabel, closable, onClose } = props;
          const tagData = availableTags.find(t => t.name === tagLabel);

          return (
            <Tag
              color={tagData?.color || 'blue'}
              closable={closable}
              onClose={onClose}
              style={{ marginRight: 3 }}
            >
              {tagLabel}
            </Tag>
          );
        }}
      />
    </div>
  );
}
